// react
import React from "react";
// template
import Menu from "../template/admin/menu/panelMenu.tsx";
import AdminHeader from "../template/admin/panelHeader/panelHeader.tsx";
import MobileMenu from "../template/admin/menu/mobileMenu.tsx";
// routes
import { Route, Routes } from "react-router-dom";
// toast
import { ToastContainer } from "react-toastify";

const Admin = (props: any) => {
    return (
        <>
            <section className="container-fluid">
                <div className="row justify-content-end">
                    <div className="col-2 d-xl-inline-block d-none" id="menu">
                        {/*menu*/}
                        <Menu routes={props.routes} />
                    </div>
                    <div className="col-xl-10 col-md-12 position-relative" id="mother-col">
                        {/* header */}
                        <AdminHeader />
                        <Routes>
                            {props.routes.map((link: any, index: number) => (
                                <Route key={index + 'route'}>
                                    <Route element={link.component} path={link.address} />
                                    {link.items?.map((item: any) => (
                                        <Route key={item.address + ''} element={item.component} path={item.address} />
                                    ))}
                                </Route>
                            ))}
                        </Routes>
                        <MobileMenu routes={props.routes} />
                    </div>
                </div>
            </section>
            <ToastContainer />
        </>
    )
}

export default Admin;